<template>
  <div>
    <div style="overflow-x: auto" v-if="showOrderResult">
      <div
        class="custom-div"
      >
        <app-heading
          :text="'NBN Order Qualification'"
          :heading="'main'"
        ></app-heading>
        <div ref="result" class="center">
          <div>

            <div>
              <p class="custom-p text-right font-weight-bold" :class="addClass">
                Status:
              </p>
              <p class="custom-p">
                <span v-html="tier1"></span>{{ result.data.status }}
              </p>
            </div>

            <v-divider class="mt-6 mb-4"></v-divider>

            <div>
              <p class="custom-p text-right font-weight-bold" :class="addClass">
                ShortFall
              </p>
            </div>

            <div v-for="(item, index) in result.data.shortfall" :key="item.type + index">
              <p class="custom-p text-right font-weight-bold" :class="addClass">
                {{ `${item.type}:` }}
              </p>
              <p class="custom-p">
                <span v-html="tier2"></span>{{ item.value }}
              </p>
            </div>

            <div v-if="result.data.reasonCode">
              <v-divider class="mt-6 mb-4"></v-divider>
              <div>
                <p class="custom-p text-right font-weight-bold" :class="addClass">
                  Reason Code:
                </p>
              </div>

              <div v-for="(item, index) in result.data.reasonCode" :key="item.type + index">
                <div>
                  <p class="custom-p text-right font-weight-bold" :class="addClass">
                    Reason:
                  </p>
                  <p class="custom-p">
                    <span v-html="tier2"></span>{{ item.reason }}
                  </p>
                </div>

                <div>
                  <p class="custom-p text-right font-weight-bold" :class="addClass">
                    Code:
                  </p>
                  <p class="custom-p">
                    <span v-html="tier2"></span>{{ item.code }}
                  </p>
                </div>

              </div>
            </div>


            <div v-if="result.data.activitySpec">
              <v-divider class="mt-6 mb-4"></v-divider>
              <div>
                <p class="custom-p text-right font-weight-bold" :class="addClass">
                  Activity Spec:
                </p>
              </div>

              <div v-for="(item, index) in result.data.activitySpec" :key="item.type + index">
                <div>
                  <p class="custom-p text-right font-weight-bold" :class="addClass">
                    Type:
                  </p>
                  <p class="custom-p">
                    <span v-html="tier2"></span>{{ item.type }}
                  </p>
                </div>
              </div>
            </div>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
export default {
  name: "OrderQualificationResult",
  data: () => ({
    showOrderResult: false,
    tier1: "&nbsp;",
    tier2: "&nbsp;&nbsp;&nbsp;",
    result:{}
  }),
  methods: {
    addClass() {
      return "first-sq";
    },
  },

}
</script>

<style lang="scss" scoped>
.custom-div {
  border: 2px solid #9e9e9e;
  border-radius: 4px;
  padding: 15px;
  margin-bottom: 15px;
  font-size: 15px !important;
}

.serviceable {
  border-color: #2cd375 !important;
}

.not-serviceable {
  border-color: #ee3923 !important;
}

.row-border {
  border-top: 1px solid #9e9e9e;
}

.custom-p {
  display: inline-block;
  margin-bottom: 2px;
}

.first-sq {
  width: 513px;
  margin-right: 10px;
  display: inline-block;
  vertical-align: top;
}

.first-order {
  width: 445px;
  margin-right: 10px;
  display: inline-block;
  vertical-align: top;
  width: 37%;
}

.center {
  margin: auto;
  width: 50%;
  border: 3px solid green;
  padding: 10px;
}

@media screen and (max-width: 1100px) {
  .custom-div {
    width: 1100px;
  }
}

</style>
